import parse from 'color-parse';

const mocaTheme = {
  getRGBA: (hex, alpha) => `rgba(${parse(hex).values.join(',')},${alpha})`,
  black: '#232323',
  white: '#FFFFFF',
  blackAbs: '#000000',
  mocaBg: '#F5F4F9',
  mocaPurple: '#463291',
  mocaOrange: '#ff7300',
  mocaGreen: '#00b4a5',
  mocaRed: '#dc1e5a',
  mocaGrey: '#AFAFB9',
  mocaLtGrey: '#dbdbdb',
  mocaThinGrey: '#b9b9b9',
  mocaThinnerGrey: '#ECECEC',
  unreadRed: '#EB1020'
}

export {
  mocaTheme as default,
  mocaTheme
};